<!--
  @Author: YuXiuJie
  @Desc: 完税证明结果展示
  @Date: 2021-08-13
-->

<template>
  <div class="page-main">
    <h2 class="title">
      <span class="line"></span>

      <span class="txt">解析错误原因：</span>
      <span class="line"></span>
    </h2>

    <div class="subtitle">
      <div class="sub-title">
        <img src="../../../static/icons/pic_state_green.png" />成功条数：{{
          successNum
        }}个
      </div>
      <div class="sub-title">
        <img src="../../../static/icons/pic_state_red.png" />失败条数：{{
          failNum
        }}个
      </div>
    </div>

    <div class="btn-wrap">
      <div class="btn-wrap-son">
        <span @click="prev" class="btnFullColor">返回</span>
        <div class="displayInline" v-if="!!exportUrl">
          <exportBtn
            :exportUrl="exportUrl"
            :text="'导出错误数据'"
            :exportParam="exportParamError"
            v-if="isSystemType == 1 || isSystemType == 3"
          ></exportBtn>
          <exportBtn
            :exportUrl="exportUrl"
            text="导出原文件"
            :exportParam="exportParamData"
            v-if="
              (isSystemType == 1 || isSystemType == 3) && from != 'noOldFile'
            "
          ></exportBtn>
        </div>
      </div>
    </div>

    <div class="center-tit">格式错误的原因如下：</div>
    <ul class="center">
      <li v-for="(item, index) of resList" :key="index">{{ item }}</li>
    </ul>
  </div>
</template>

<script>
import { getLocal } from "../../filters/filters";
import CoopList from "../coopManage/coopList.vue";
export default {
  name: "tax-res",

  components: { CoopList },

  computed: {},

  data() {
    return {
      resList: [],
      successNum: "",
      failNum: "",
      exportUrl: "",
      exportParamError: {
        type: 2,
        cooperatorId: JSON.parse(getLocal("userMessage")).companyId || "",
        open: 0
      },

      exportParamData: {
        type: 1,
        cooperatorId: JSON.parse(getLocal("userMessage")).companyId || "",
        open: 0
      },
      isSystemType: JSON.parse(getLocal("userMessage")).systemType || "",
      from: "" //提现模式，直发模式
    };
  },

  created() {
    this.from = this.$route.query.from || "";
    this.exportUrl = this.$route.query.url;
  },

  mounted() {
    this.getTaxRes(this.resList);
  },

  methods: {
    // 获取完税证明上传结果
    getTaxRes() {
      this.resList = JSON.parse(
        getLocal("taxUploadErrRes").statusText
      ).errorResult;
      this.successNum = JSON.parse(
        getLocal("taxUploadErrRes").statusText
      ).trueSize;
      this.failNum = JSON.parse(
        getLocal("taxUploadErrRes").statusText
      ).errorSize;
    },

    //返回上级页面
    prev() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin-top: 88px;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #262626;
  line-height: 37px;
  .line {
    display: inline-block;
    margin-bottom: 9px;
    width: 60px;
    height: 1px;
    background: #e9e9e9;
  }
  .txt {
    padding: 36px;
  }
}
.subtitle {
  width: 320px;
  margin: 0 auto;
  margin-top: 56px;
  display: flex;
  .sub-title {
    width: 165px;
    height: 28px;
    line-height: 28px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    img {
      width: 28px;
      height: 28px;
    }
  }
}
.center-tit {
  width: 1000px;
  height: 56px;
  margin: 0 auto;
  background: #eeeeee;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #272727;
  line-height: 56px;
  text-align: left;
  text-indent: 2em;
}
.center li {
  margin: 0 auto;
  width: 1000px;
  height: 56px;
  line-height: 56px;
  text-align: left;
  text-indent: 2em;
  background: #ffffff;
  border-bottom: 1px solid #eee;
}
.btn-wrap {
  width: 1000px;
  height: 32px;
  margin: 0 auto;
  margin-top: 48px;
  margin-bottom: 16px;
  .btn-wrap-son {
    text-align: left;
  }
}
.displayInline {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/staticPages/taxUploadErrRes.vue